













































































































import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { dutyListBatchServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import ViewDialog from '@/views/responsibility/unit/viewDialog.vue';
import EditBatchDialog from '@/views/inventoryManagement/batchUnit/editBatchDialog.vue';
import GenerateTaskDialog from '@/views/inventoryManagement/unit/generateTaskDialog.vue';

@Component({
  components: {
    GenerateTaskDialog,
    EditBatchDialog,
    ViewDialog,
    PagingUnit,
  },
  mixins: [TableStripe],
})
export default class DutyListBatch extends Vue {
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  // 日期范围
  dateRange: any = [];
  // 控制列表删除按钮
  total = 0; // 总共多少条数据
  pageIndex = 1; // 总共多少条数据
  private editData: any = {}; //选中的单挑编辑项
  private NewType: any = ''; //选中的单挑编辑项
  obj: object = {}; // 搜索需要的对象
  // 详情页面标志
  details = false;
  // 表单数据对象
  formData: any = {
    search: '',
  };
  // table 数据对象
  tableData: any = [];

  created() {
    // 获取分页数据
    this.getPageData();
    this.details = false;
  }

  viewTaskInfo(data: any) {
    const viewDialog: any = 'viewDialog';
    const viewDialogRef: any = this.$refs[viewDialog];
    viewDialogRef.showDialog(data);
  }

  // 新增 、 编辑
  createBatch(type: any, data?: any) {
    this.details = true;
    switch (type) {
      case 'add':
        this.pageIndex = 2;
        this.NewType = type;
        break;
      case 'edit':
        this.pageIndex = 3;
        this.NewType = type;
        this.editData = data;
        break;
    }
  }

  // 打开删除事件
  openDeletedialog(id: any) {
    this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.deleteList(id);
        this.getPageData();
      })
      .catch(() => {
        this.$message.info('已取消删除');
      });
  }

  // 删除
  private deleteList(newId: any) {
    dutyListBatchServer.deleteBatchRecordList(newId).then((res: any) => {
      if (res.code === '200') {
        this.$message.success('删除成功');
        this.getPageData();
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  // 查看
  viewManagement(data: any) {
    this.details = true;
    this.NewType = 'see';
    this.pageIndex = 4;
    this.editData = data;
  }

  /**
   * 查看履职清单列表
   */
  getDutyList(data: any) {
    this.$router.push({ name: 'EnterprisePerformanceList', query: { dutyRuleListBatchId: data.id, dutyRuleListBatchName: data.name } });
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    this.pageIndex = 1;
    // 发起接口请求，获取分页数据
    dutyListBatchServer
      .getBatchRecordPageList({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        search: this.formData.search ? this.formData.search : null,
        startDate: this.dateRange.length > 0 ? this.dateRange[0] : null,
        endDate: this.dateRange.length > 0 ? this.dateRange[1] : null,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetFormData() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.dateRange = [];
    this.formData = {
      search: '',
    };
    this.getPageData();
  }
}
